import React, { useEffect, useState } from "react";
import axios from "axios";

const COUNTRY_ID_MAP = {
  Canada: 1,
  "United States": 2,
};

const CountryProvinceSelector = ({
  country,
  province,
  onChange,
  countries,
  disabled = false,
}) => {
  const [provinces, setProvinces] = useState([]);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const countryId = COUNTRY_ID_MAP[country];
    if (!countryId) {
      setProvinces([]);
      return;
    }

    axios
      .get(`${API_BASE}/api/dropdowns/provinces/${countryId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        const list = Array.isArray(res.data)
          ? res.data
          : res.data?.provinces || [];

        setProvinces(list);
      })
      .catch(() => setProvinces([]));
  }, [country, API_BASE]);

  const hasDropdown = ["Canada", "United States"].includes(country);

  return (
    <div className="row mb-3">
      {/* Country */}
      <div className="col-md-6">
        <label className="form-label">Country *</label>
        <select
          className="form-select"
          value={country}
          disabled={disabled}
          onChange={(e) => onChange("country", e.target.value)}
          required
        >
          <option value="">Select Country</option>
          {countries.map((c) => (
            <option key={c.id} value={c.country_name}>
              {c.country_name}
            </option>
          ))}
        </select>
      </div>

      {/* Province / State */}
      <div className="col-md-6">
        <label className="form-label">Province / State *</label>
        {hasDropdown ? (
          <select
            className="form-select"
            value={province}
            disabled={disabled}
            onChange={(e) => onChange("province", e.target.value)}
            required
          >
            <option value="">Select</option>
            {provinces.map((p) => (
              <option key={p.id} value={p.province_name}>
                {p.province_name}
              </option>
            ))}
          </select>
        ) : (
          <input
            type="text"
            className="form-control"
            value={province}
            disabled={disabled}
            onChange={(e) => onChange("province", e.target.value)}
            required
          />
        )}
      </div>
    </div>
  );
};

export default CountryProvinceSelector;
